
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21 15H23V17H21V15ZM21 11H23V13H21V11ZM23 19H21V21C22 21 23 20 23 19ZM13 3H15V5H13V3ZM21 7H23V9H21V7ZM21 3V5H23C23 4 22 3 21 3ZM1 7H3V9H1V7ZM17 3H19V5H17V3ZM17 19H19V21H17V19ZM3 3C2 3 1 4 1 5H3V3ZM9 3H11V5H9V3ZM5 3H7V5H5V3ZM1 11V19C1 20.1 1.9 21 3 21H15V13C15 11.9 14.1 11 13 11H1ZM3.63 18.19L5.12 16.28C5.32 16.03 5.69 16.02 5.9 16.27L7.29 17.94L9.39 15.24C9.59 14.98 9.99 14.98 10.18 15.25L12.4 18.21C12.65 18.54 12.41 19.01 12 19.01H4.02C3.61 19 3.37 18.52 3.63 18.19Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-photo-size-select-large`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPhotoSizeSelectLarge

    ```js
    <b-new-b-icon-photo-size-select-large />
    ```
</docs>


